import { useRef } from 'react';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import 'react-multi-date-picker/styles/layouts/mobile.css';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import gregorian from 'react-date-object/calendars/gregorian';
import persian from 'react-date-object/calendars/persian';
import persianLocale from 'react-date-object/locales/persian_fa';
import gregorianEn from 'react-date-object/locales/gregorian_en';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import keywordsApi from '@/app/KeywordTracker/api/keywordsApi';
import TimePickerStyles from './TimePickerStyles';

export default function TimePickerSpecific({ availableDays, time, setTime }) {
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  const datePickerRef = useRef(null);
  const availableDates = availableDays?.map(day => new Date(day * 1000));
  const dispatch = useDispatch();

  return (
    <div id="timepicker-specific-wrapper" className="w-100">
      <style>{`
        #timepicker-specific-wrapper .rmdp-container{
        display:${isMdUp ? 'inline-block' : 'block'} !important;
        }
        `}</style>
      {isMdUp ? (
        <DatePicker
          value={
            time
              ? new DateObject({
                  date: time * 1000,
                  locale: persianLocale,
                  calendar: persian
                })
              : new DateObject().convert(persian, persianLocale)
          }
          onChange={d => {
            setTime(d ? d.toUnix() : null);
            dispatch(keywordsApi.util.invalidateTags(['KeywordsMap']));
          }}
          format="YYYY-MM-DD"
          ref={datePickerRef}
          className="custom-calendar rmdp-prime w-100 bg-custom"
          calendar={persian}
          locale={persianLocale}
          mapDays={
            availableDays?.length > 0
              ? ({ date }) => {
                  let props = {};
                  date.convert(gregorian, gregorianEn);
                  const currentDay = date.day;
                  const currentMonth = date.month.index; // ماه 0-11 را برمی‌گرداند
                  const currentYear = date.year;

                  const isAvailable = availableDates.some(availableDate => {
                    return (
                      availableDate.getUTCDate() === currentDay &&
                      availableDate.getUTCMonth() === currentMonth &&
                      availableDate.getUTCFullYear() === currentYear
                    );
                  });

                  if (!isAvailable) {
                    props.disabled = true;
                    props.style = { color: getColor('gray-400'), opacity: 0.5 };
                  }
                  date.convert(persian, persianLocale);

                  return props;
                }
              : undefined
          }
          style={{ padding: 4 }}
          render={(value, openCalendar) => (
            <div className="position-relative">
              <Form.Control
                size="sm"
                onClick={openCalendar}
                value={value}
                className="ps-4"
                readOnly
              />
              <FontAwesomeIcon
                icon="calendar-alt"
                style={{
                  color: getColor('navbar-vertical-default-link-active-color')
                }}
                className=" position-absolute top-50 translate-middle-y ms-2"
              />
            </div>
          )}
          buttons
          plugins={[<DatePanel sort="date" key="DatePanel" />]}
        />
      ) : (
        <DatePicker
          value={
            time
              ? new DateObject({
                  date: time * 1000,
                  locale: persianLocale,
                  calendar: persian
                })
              : new DateObject().convert(persian, persianLocale)
          }
          onChange={d => {
            setTime(d ? d.toUnix() : null);
            dispatch(keywordsApi.util.invalidateTags(['KeywordsMap']));
            datePickerRef?.current?.closeCalendar();
          }}
          format="YYYY-MM-DD"
          ref={datePickerRef}
          className="custom-calendar rmdp-mobile bg-custom"
          calendar={persian}
          locale={persianLocale}
          mapDays={
            availableDays?.length > 0
              ? ({ date }) => {
                  let props = {};
                  date.convert(gregorian, gregorianEn);
                  const currentDay = date.day;
                  const currentMonth = date.month.index; // ماه 0-11 را برمی‌گرداند
                  const currentYear = date.year;

                  const isAvailable = availableDates.some(availableDate => {
                    return (
                      availableDate.getUTCDate() === currentDay &&
                      availableDate.getUTCMonth() === currentMonth &&
                      availableDate.getUTCFullYear() === currentYear
                    );
                  });

                  if (!isAvailable) {
                    props.disabled = true;
                    props.style = { color: getColor('gray-400'), opacity: 0.5 };
                  }
                  date.convert(persian, persianLocale);

                  return props;
                }
              : undefined
          }
          style={{ padding: 4 }}
          render={(value, openCalendar) => (
            <div className="position-relative">
              <Form.Control
                size="sm"
                onClick={openCalendar}
                value={value}
                className="ps-4"
                readOnly
              />
              <FontAwesomeIcon
                icon="calendar-alt"
                style={{
                  color: getColor('navbar-vertical-default-link-active-color')
                }}
                className=" position-absolute top-50 translate-middle-y ms-2"
              />
            </div>
          )}
          buttons
        />
      )}
      <TimePickerStyles />
    </div>
  );
}
